import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { RoundedCloseIcon } from "../../ui/icons/CloseIcon"
import { TickIcon } from "../../ui/icons/TickIcon"
import { ButtonComponent } from "../../ui/molecules/button/newButton"
import { MadfarmInput } from "../../ui/molecules/input/newInput"
import MultiSelectCheckbox from "../../ui/molecules/multiSelectCheckbox"
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static"
import { CodexSampleStatusOptions, optionsFormatter, OptionType } from "../../utils"
import { CodexSamplesEdit, GetAllCodexSamples, resetCodexSamplesEditStatus, resetGetAllCodexSamplesStatus, setCodexSampleEditEnvelopeNumbers, setCodexSampleEditStatus, setGetAllCodexSampleEnvelopNumber, setGetAllCodexSamplePersonalManagementId, setGetAllCodexSampleStatus } from "./slice"

export function GestionePrelieviEdit() {
    const dispatch = useAppDispatch()
    const codexSampleState = useAppSelector(state => state.codexSample)
    const [selectionFlag, setSelectionFlag] = useState<string>('MULTIPLE')
    const [selectedEnvelopes, setSelectedEnvelopes] = useState<OptionType[]>([])
    const [envelopeOptions, setEnvelopeOptions] = useState<OptionType[]>([])
    const [foundEnvelope, setFoundEnvelope] = useState<[boolean, string | null, string | null]>([false, null, null])

    const addZerosToNumber = (envelopNumber: string) =>
        `${Array(7 - envelopNumber.length).fill('0').join('')}${envelopNumber}`

    useEffect(() => {
        setSelectedEnvelopes([])
        dispatch(setCodexSampleEditEnvelopeNumbers([]))
        if (
            codexSampleState.getAllCodexSampleFilters.personalManagementId !== undefined &&
            codexSampleState.getAllCodexSampleFilters.status !== undefined
        ) {
            dispatch(GetAllCodexSamples({
                itemsPerPage: 0, page: 0,
                personalManagementId: codexSampleState.getAllCodexSampleFilters.personalManagementId,
                status: codexSampleState.getAllCodexSampleFilters.status,
            }))
        }
    }, [codexSampleState.getAllCodexSampleFilters.personalManagementId, codexSampleState.getAllCodexSampleFilters.status])

    useEffect(() => {
        if (codexSampleState.getAllCodexSamplesStatus === 'successfully' && codexSampleState.getAllCodexSampleResponse !== undefined) {
            dispatch(resetGetAllCodexSamplesStatus())
            if (selectionFlag === 'MULTIPLE') {
                setEnvelopeOptions(codexSampleState.getAllCodexSampleResponse.data.map(env => ({
                    value: String(env.envelopNumber),
                    label: addZerosToNumber(String(env.envelopNumber)),
                })))
                return
            }
            if (codexSampleState.getAllCodexSampleResponse.data.length > 0 && codexSampleState.getAllCodexSampleResponse.data[0].envelopNumber !== undefined) {
                setFoundEnvelope([true, String(codexSampleState.getAllCodexSampleResponse.data[0].envelopNumber), codexSampleState.getAllCodexSampleResponse.data[0].status])
            }
        }
    }, [codexSampleState.getAllCodexSamplesStatus])

    useEffect(() => {
        if (codexSampleState.codexSamplesEditStatus === 'successfully') {
            setSelectedEnvelopes([])
            dispatch(setCodexSampleEditEnvelopeNumbers([]))
            if (selectionFlag === 'MULTIPLE') {
                dispatch(GetAllCodexSamples({
                    itemsPerPage: 0, page: 0,
                    personalManagementId: codexSampleState.getAllCodexSampleFilters.personalManagementId,
                    status: codexSampleState.getAllCodexSampleFilters.status,
                }))
            } else {
                dispatch(setCodexSampleEditEnvelopeNumbers([]))
                dispatch(setCodexSampleEditStatus(undefined))
                dispatch(setGetAllCodexSampleEnvelopNumber(''))
                setFoundEnvelope([false, null, null])
            }
        }
    }, [codexSampleState.codexSamplesEditStatus])

    useEffect(() => {
        if (selectionFlag === 'MULTIPLE') {
            dispatch(setGetAllCodexSampleEnvelopNumber(""))
            setFoundEnvelope([false, null, null])
        } else {
            dispatch(setGetAllCodexSamplePersonalManagementId(undefined))
            dispatch(setGetAllCodexSampleStatus(undefined))
            dispatch(setCodexSampleEditEnvelopeNumbers([]))
            setSelectedEnvelopes([])
        }
    }, [selectionFlag])

    useEffect(() => {
        if (selectionFlag === 'SINGLE' && codexSampleState.getAllCodexSampleFilters.envelopNumber !== '') {
            setFoundEnvelope([false, null, null])
            dispatch(GetAllCodexSamples({ itemsPerPage: 1, page: 0, envelopNumber: codexSampleState.getAllCodexSampleFilters.envelopNumber }))
        }
    }, [codexSampleState.getAllCodexSampleFilters.envelopNumber])

    return (
        <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
            <div className="bg-brandPrimary-600 px-6 py-4">
                <span className="text-white font-semibold text-lg">Buste Prelievo Campioni </span>
                <span className="text-brandPrimary-300 font-semibold">/</span>
                <span className="text-brandPrimary-100 font-semibold uppercase"> Modifica</span>
            </div>

            <div className="p-6 flex flex-col gap-8">
                <div className="flex flex-col gap-4">
                    <label className="flex items-center gap-3 cursor-pointer">
                        <input
                            type="radio"
                            name="selectionFlag"
                            value="MULTIPLE"
                            checked={selectionFlag === 'MULTIPLE'}
                            onChange={() => setSelectionFlag('MULTIPLE')}
                            className="accent-brandPrimary-500 w-4 h-4"
                        />
                        <span className="text-sm font-semibold text-brandPrimary-700">
                            Modifica Stato Buste Prelievo Campioni del Tecnico Ispettore
                        </span>
                    </label>

                    <div className="ml-7 flex flex-col gap-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <MadfarmStaticSelect
                                menuPortalTargetIsNotBody
                                label="Tecnico Ispettore"
                                placeholder="Seleziona ispettore..."
                                options={codexSampleState.PMResources}
                                value={codexSampleState.getAllCodexSampleFilters.personalManagementId}
                                onChange={(value) => {
                                    //@ts-ignore
                                    dispatch(setGetAllCodexSamplePersonalManagementId(value?.value))
                                }}
                                disabled={selectionFlag === 'SINGLE'}
                                errorLabel="Ispettore mancante"
                                noOptionsMessage={""}
                            />
                            <MadfarmStaticSelect
                                menuPortalTargetIsNotBody
                                label="Stato Buste Prelievo Campione"
                                placeholder="Seleziona stato..."
                                options={CodexSampleStatusOptions}
                                value={codexSampleState.getAllCodexSampleFilters.status}
                                onChange={(value) => {
                                    //@ts-ignore
                                    dispatch(setGetAllCodexSampleStatus(value?.value))
                                }}
                                disabled={selectionFlag === 'SINGLE'}
                                errorLabel="Stato mancante"
                                noOptionsMessage={""}
                            />
                        </div>

                        <div className="pb-4 border-b border-neutral-200">
                            <MultiSelectCheckbox
                                label="Elenco Buste Prelievo Campione del Tecnico Ispettore"
                                disabled={selectionFlag === 'SINGLE'}
                                errorLabel="Non è stata selezionata alcuna busta!"
                                onChange={(e) => {
                                    setSelectedEnvelopes(e.value)
                                    dispatch(setCodexSampleEditEnvelopeNumbers(e.value))
                                }}
                                value={selectedEnvelopes}
                                option={envelopeOptions}
                                placeholder=""
                                selectAllLabel="Tutte"
                            />
                        </div>

                        {selectedEnvelopes.length > 0 && (
                            <div className="flex items-end gap-4">
                                <div className="flex-1">
                                    <MadfarmStaticSelect
                                        menuPortalTargetIsNotBody
                                        label="Nuovo Stato"
                                        placeholder="Seleziona nuovo stato..."
                                        options={CodexSampleStatusOptions}
                                        onChange={(value) => {
                                            //@ts-ignore
                                            dispatch(setCodexSampleEditStatus(value?.value))
                                        }}
                                        disabled={selectionFlag === 'SINGLE'}
                                        errorLabel="Stato mancante"
                                        noOptionsMessage={""}
                                    />
                                </div>
                                <ButtonComponent
                                    size="md"
                                    iconPosition="left"
                                    icon={<TickIcon />}
                                    variant="outline"
                                    color="gray"
                                    label="Assegna Nuovo Stato"
                                    disabled={selectionFlag === 'SINGLE'}
                                    onClick={() => dispatch(CodexSamplesEdit(codexSampleState.codexSamplesEditRequest))}
                                />
                            </div>
                        )}

                        {codexSampleState.codexSamplesEditStatus === 'successfully' && selectionFlag === 'MULTIPLE' && (
                            <div className="flex items-center gap-4">
                                <div className="w-1 h-10 rounded bg-green-500 shrink-0" />
                                <div className="flex items-center gap-4 flex-1">
                                    <span className="text-sm text-green-700">Stato buste correttamente modificato.</span>
                                    <button onClick={() => dispatch(resetCodexSamplesEditStatus())}>
                                        <RoundedCloseIcon color="#166428" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="border-t border-neutral-200" />
                <div className="flex flex-col gap-4">
                    <label className="flex items-center gap-3 cursor-pointer">
                        <input
                            type="radio"
                            name="selectionFlag"
                            value="SINGLE"
                            checked={selectionFlag === 'SINGLE'}
                            onChange={() => setSelectionFlag('SINGLE')}
                            className="accent-brandPrimary-500 w-4 h-4"
                        />
                        <span className="text-sm font-semibold text-brandPrimary-700">
                            Modifica Stato Busta Prelievo Campioni
                        </span>
                    </label>

                    <div className="ml-7 flex flex-col gap-4">
                        <div className="w-64">
                            <MadfarmInput
                                label="Busta Prelievo Campioni n."
                                placeholder="Specifica n. busta..."
                                value={codexSampleState.getAllCodexSampleFilters.envelopNumber}
                                disabled={selectionFlag === 'MULTIPLE'}
                                onChangeText={(text) => {
                                    dispatch(setGetAllCodexSampleEnvelopNumber(text))
                                    dispatch(setCodexSampleEditEnvelopeNumbers([text]))
                                }}
                            />
                        </div>

                        {foundEnvelope[0] && (
                            <div className="flex flex-col gap-4">
                                <div className="flex items-center gap-4">
                                    <div className="w-1 h-12 rounded bg-green-500 shrink-0" />
                                    <div className="flex items-center gap-6 flex-1">
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-green-700">Numero busta</div>
                                            <div className="text-sm text-green-600">{addZerosToNumber(foundEnvelope[1]!)}</div>
                                        </div>
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-green-700">Stato attuale</div>
                                            <div className="text-sm text-green-600">{optionsFormatter(foundEnvelope[2]!, CodexSampleStatusOptions)}</div>
                                        </div>
                                        <button onClick={() => {
                                            setFoundEnvelope([false, null, null])
                                            dispatch(setGetAllCodexSampleEnvelopNumber(''))
                                            dispatch(setCodexSampleEditEnvelopeNumbers([]))
                                        }}>
                                            <RoundedCloseIcon color="#166428" />
                                        </button>
                                    </div>
                                </div>

                                <div className="flex items-end gap-4">
                                    <div className="flex-1">
                                        <MadfarmStaticSelect
                                            menuPortalTargetIsNotBody
                                            label="Stato"
                                            placeholder="Seleziona stato..."
                                            options={CodexSampleStatusOptions}
                                            value={codexSampleState.codexSamplesEditRequest.status}
                                            onChange={(value) => {
                                                //@ts-ignore
                                                dispatch(setCodexSampleEditStatus(value?.value))
                                            }}
                                            errorLabel="Stato mancante"
                                            noOptionsMessage={""}
                                        />
                                    </div>
                                    <ButtonComponent
                                        size="md"
                                        iconPosition="left"
                                        icon={<TickIcon />}
                                        variant="outline"
                                        color="gray"
                                        label="Assegna Nuovo Stato"
                                        onClick={() => dispatch(CodexSamplesEdit(codexSampleState.codexSamplesEditRequest))}
                                    />
                                </div>
                            </div>
                        )}

                        {codexSampleState.codexSamplesEditStatus === 'successfully' && selectionFlag === 'SINGLE' && (
                            <div className="flex items-center gap-4">
                                <div className="w-1 h-10 rounded bg-green-500 shrink-0" />
                                <div className="flex items-center gap-4 flex-1">
                                    <span className="text-sm text-green-700">Stato busta correttamente modificato.</span>
                                    <button onClick={() => dispatch(resetCodexSamplesEditStatus())}>
                                        <RoundedCloseIcon color="#166428" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}